export default __webpack_public_path__ + "static/media/cash.3a9fcfb0.png";